/**
 * Utilitários do campo de valor dos formulários.
 *
 * O campo guarda o texto digitado, não um número. Converter a cada tecla
 * impede o usuário de digitar decimais: "12," ou "12." viram 12 e o separador
 * some da tela assim que é digitado. A conversão acontece só na hora de salvar.
 */

/**
 * Mantém apenas o que pode fazer parte de um valor enquanto se digita.
 *
 * O sinal negativo é opcional porque nos lançamentos quem define entrada ou
 * saída são os botões Crédito/Débito — deixar digitar "-" ali só criaria
 * conflito com essa escolha. Já o saldo inicial de uma conta pode ser
 * negativo e não tem botão nenhum, então lá o sinal é aceito.
 */
export function limparEntradaValor(
  texto: string,
  permitirNegativo = false,
): string {
  const semRuido = texto.replace(/[^\d.,-]/g, '');
  const negativo = permitirNegativo && semRuido.startsWith('-');

  return (negativo ? '-' : '') + semRuido.replace(/-/g, '');
}

/**
 * Converte o texto digitado em número. O separador decimal é o último ponto ou
 * vírgula do texto, então "1.234,56" e "1,234.56" resultam em 1234.56, e
 * "12,5" e "12.5" em 12.5. Devolve NaN quando não há número.
 */
export function valorParaNumero(texto: string): number {
  const limpo = limparEntradaValor(texto, true);
  const negativo = limpo.startsWith('-');
  const digitos = negativo ? limpo.slice(1) : limpo;

  if (!digitos) return NaN;

  const posSeparador = Math.max(
    digitos.lastIndexOf(','),
    digitos.lastIndexOf('.'),
  );

  const numero =
    posSeparador === -1
      ? Number(digitos)
      : Number(
          `${digitos.slice(0, posSeparador).replace(/[.,]/g, '') || '0'}.${
            digitos.slice(posSeparador + 1).replace(/[.,]/g, '') || '0'
          }`,
        );

  return negativo ? -numero : numero;
}
